@if(!!progress) {
    <div class="progress">
        <div class="progress-bar progress-bar-striped" role="progressbar" style="width: {{progress}}%" aria-valuenow="{{progress}}" aria-valuemin="0" aria-valuemax="100">
            @if(showPercentage) {
                {{progress}}%
            }
        </div>
    </div>
}